"use strict";

let  BuildStageConfig = {
  archivedUrl: 'https://exhibition.tsm.tsinghua.edu.cn',
}

export default BuildStageConfig
